export const COOKIE_NAME = 'bihai_locale';
export const locales = {
  cn: { name: '简体中文', tag: 'zh-CN', menuLayout: 'compact' },
  'zh-Hant': { name: '繁體中文', tag: 'zh-Hant', menuLayout: 'compact' },
  en: { name: 'English', tag: 'en', menuLayout: 'expanded' },
  es: { name: 'Español', tag: 'es', menuLayout: 'expanded' },
};
export const isLocale = value => Object.hasOwn(locales, value);
export function readLocaleCookie(cookie = '') {
  for (const part of cookie.split(';')) {
    const [name, ...value] = part.trim().split('=');
    if (name !== COOKIE_NAME) continue;
    try { const decoded = decodeURIComponent(value.join('=')); if (isLocale(decoded)) return decoded; }
    catch { /* Ignore malformed or unsupported preferences. */ }
  }
  return null;
}
export function preferredLocale(saved, languages = []) {
  if (isLocale(saved)) return saved;
  for (const tag of languages) {
    if (/^zh-(?:Hant|TW|HK|MO)(?:-|$)/i.test(tag)) return 'zh-Hant';
    if (/^zh(?:-|$)/i.test(tag)) return 'cn';
    if (/^en(?:-|$)/i.test(tag)) return 'en';
    if (/^es(?:-|$)/i.test(tag)) return 'es';
  }
  return 'cn';
}
export function localeCookie(value, hostname, secure = false) {
  const domain = ['bihai.life', 'bihai.top'].find(d => hostname === d || hostname.endsWith(`.${d}`));
  const choice = isLocale(value) ? value : '';
  return `${COOKIE_NAME}=${choice}; Path=/; Max-Age=${choice ? 31536000 : 0}; SameSite=Lax${domain ? `; Domain=${domain}` : ''}${secure ? '; Secure' : ''}`;
}
// Source-message keys stay stable when another message is added. Resources are
// checked for collisions; business values must never pass through this helper.
export function messageKey(source) {
  let hash = 2166136261;
  for (const character of source) hash = Math.imul(hash ^ character.codePointAt(0), 16777619);
  return `m${(hash >>> 0).toString(16)}`;
}
